import * as Yup from 'yup';

const LOGIN_SCHEMA = Yup.object().shape({
	mc_email_address: Yup.string().email('Invalid email address').required('This field is required'),
	mc_password: Yup.string().required('This field is required')
});

export default LOGIN_SCHEMA;
